/**
 * Error carrying the HTTP status so consumers can distinguish a 403 (role not
 * privileged — a first-class "not authorized" UI state) and a 401 (re-auth)
 * from a generic failure. Structural sibling of `AttensiFetchError`: both
 * expose `.status`, which is what `isHttpStatus` matches on.
 */
export class FastApiV1Error extends Error {
  constructor(
    public readonly status: number,
    statusText: string
  ) {
    super(`Fast api/v1 request failed: ${status} ${statusText}`)
    this.name = 'FastApiV1Error'
  }
}
